import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styled from 'styled-components';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const buttonVariants = {
        hidden: {
            opacity: 0,
            scale: 0,
            y: 20
        },
        visible: {
            opacity: 1,
            scale: 1,
            y: 0,
            transition: {
                duration: 0.3,
                ease: "easeOut"
            }
        },
        hover: {
            scale: 1.1,
            y: -2,
            transition: {
                duration: 0.2,
                ease: "easeInOut"
            }
        },
        tap: {
            scale: 0.95
        }
    };

    return (
        <AnimatePresence>
            {isVisible && (
                <ScrollButton
                    variants={buttonVariants}
                    initial="hidden"
                    animate="visible"
                    exit="hidden"
                    whileHover="hover"
                    whileTap="tap"
                    onClick={scrollToTop}
                >
                    <KeyboardArrowUpIcon />
                </ScrollButton>
            )}
        </AnimatePresence>
    );
};

const ScrollButton = styled(motion.button)`
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: linear-gradient(135deg, #01a479 0%, #019a6b 100%);
    border: none;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 15px rgba(1, 164, 121, 0.3);
    z-index: 1000;

    &:hover {
        box-shadow: 0 6px 20px rgba(1, 164, 121, 0.4);
    }

    svg {
        font-size: 24px;
    }

    @media (max-width: 768px) {
        bottom: 20px;
        right: 20px;
        width: 45px;
        height: 45px;

        svg {
            font-size: 20px;
        }
    }
`;

export default ScrollToTop;